import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { Space, Badge } from "@masterteam/mt-design-react";
import useIsAr from "../../Hooks/useIsAr";
import SubItemsMenu from "./SubItemsMenu";
import "./style.scss";

function Navigator({ location, getNavigatorItems }) {
  const [allowedScreens, tasksCount] = useSelector(({ user, taskCenter }) => [
    user.user.screens,
    taskCenter?.tasks,
  ]);
  const [isAr] = useIsAr();
  const [index, setIndex] = useState(0);
  const [navigatorItems, setNavigatorItems] = useState([]);

  const isTaskCenter = (path) => {
    const { pathname } = location;

    return pathname?.includes("task-center") && path?.includes("task-center");
  };

  useEffect(() => {
    setNavigatorItems(getNavigatorItems());
  }, []);

  useEffect(() => {
    const { pathname } = location;
    setIndex(
      navigatorItems.findIndex((item) => {
        if (item?.subItems)
          return item.subItems.some((e) => e.path === pathname);

        return item.path === pathname;
      })
    );
  }, [location, navigatorItems]);

  return (
    <div className="main-layout-container">
      <div className="layout-header d-flex">
        {navigatorItems.map(
          (item, i) =>
            allowedScreens.includes(item.key) &&
            (item?.subItems ? (
              <SubItemsMenu
                key={i}
                item={item}
                isActive={index === i}
                setIndex={setIndex}
                activeIndex={index}
                pathname={location.pathname}
                index={i}
              />
            ) : (
              <Link to={item?.path} key={i}>
                <Space
                  align="center"
                  onClick={() => setIndex(i)}
                  className={`menu-item ${
                    (index === i || isTaskCenter(item?.path)) && "active"
                  }`}
                >
                  {item?.icon && (
                    <div className="menu-item_icon">{item?.icon}</div>
                  )}
                  {item.name ? (
                    <FormattedMessage
                      id={item.name}
                      defaultMessage={item.name}
                    />
                  ) : isAr ? (
                    item.arabicName
                  ) : (
                    item.englishName
                  )}

                  {item?.isTaskCenter ? (
                    <Space
                      className="tasks-count-wrapper"
                      align="center"
                      justify="center"
                    >
                      <Badge
                        shape="round"
                        variant="secondary"
                        size="small"
                        className="tasks-count"
                      >
                        {tasksCount >= 100 ? "+99" : tasksCount}
                      </Badge>
                    </Space>
                  ) : null}
                </Space>
              </Link>
            ))
        )}
      </div>
    </div>
  );
}

export default withRouter(Navigator);
